/* eslint-disable @remind/remind/no-on-functions */
/* @flow */
import PropTypes from 'prop-types';
import * as React from 'react';
import humanparser from 'humanparser';
import AuthActions from 'auth/AuthActions';
import ToastActions from 'actions/ToastActions';
import PromptActions from 'actions/PromptActions';
import LinkDevicePage from 'user/components/LinkDevicePage';
import { PromptNames } from 'constants/PromptConstants';
import GroupActions from 'groups/actions/GroupActions';
import UserActions from 'user/UserActions';
import errorLogger from 'utils/errorLogger';
import invariant from 'invariant';
import JoinFlowGroupStorage from '../data/JoinFlowGroupStorage';

type Props = {
  location: Object,
  params: Object,
};

type State = {
  groupCode: string,
  address: string,
  token: string,
  name: ?string,
};

class JoinConfirmSmsDevicePage extends React.Component<Props, State> {
  // eslint-disable-next-line @remind/remind/legacy-context
  static contextTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    router: PropTypes.object.isRequired,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      groupCode: props.params.groupCode,
      address: props.location.query.address,
      token: props.location.query.token,
      name: props.location.query.name,
    };
  }

  onDone = (token?: string) => {
    invariant(token, 'JoinConfirmSmsDevicePage must have a token');
    const onUserUpdateSuccess = user => {
      GroupActions.subscribeToGroupWithCode(this.state.groupCode).then(
        () => {
          JoinFlowGroupStorage.setJoinedClassName(this.state.groupCode);
          this.context.router.push(
            user.getRole() ? '/classes?origin=subscribed' : '/join/role_picker'
          );
        },
        () => {
          this.context.router.push(`/join/role_picker/${this.state.groupCode}`);
        }
      );
    };

    const onUserUpdateFailure = () => {
      ToastActions.showErrorToast('An error occured');
      this.context.router.push(`/join/${this.state.groupCode}`);
    };

    const onSessionExchanged = () => {
      // bypass the setup sms device setup step.
      PromptActions.recordDismissal(PromptNames.NUX_SETUP_SMS_DEVICE);
      const human = humanparser.parseName(this.state.name);

      UserActions.update({
        prefix: human.salutation,
        last_name: human.lastName,
        first_name: human.firstName,
      }).then(onUserUpdateSuccess, onUserUpdateFailure);
    };

    AuthActions.accessTokenSignIn(token)
      .then(onSessionExchanged)
      .catch(errorLogger('JoinConfirmSmsDevicePage onDone failed'));
  };

  render() {
    return (
      <LinkDevicePage {...this.state} onDone={this.onDone} instantResend deviceType="phoneNumber" />
    );
  }
}

export default JoinConfirmSmsDevicePage;
